import { Divider, Drawer } from '@mui/material';
import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Fragment } from 'react';
import PainelFiltrosToolbar from './PainelFiltrosToolbar';
import ReactComponent from './ReactComponent';
import FiltroBooleano from './sessao/FiltroBooleano';
import FiltrosAtivos from './sessao/FiltrosAtivos';
import FiltroSelecao from './sessao/FiltroSelecao';

class DrawerFiltros extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            fecharPainelFiltros: action,
            filtrosPesquisados: computed,
            renderConteudoDrawer: computed,
            renderFiltros: computed
        });
    }

    fecharPainelFiltros = () => {
        this.store.painelFiltros = false;
    };

    get filtrosPesquisados() {
        if (this.store.valorCampoPesquisaFiltros) {
            return this.store.filtros.filtros.filter(
                (filtro) =>
                    this.normalizarString(filtro.label).indexOf(
                        this.normalizarString(this.store.valorCampoPesquisaFiltros)
                    ) > -1
            );
        }
        return this.store.filtros.filtros;
    }

    render() {
        return (
            <Drawer
                open={this.store.painelFiltros}
                onClose={this.fecharPainelFiltros}
                style={{ zIndex: 1330 }}
            >
                {this.renderConteudoDrawer}
            </Drawer>
        );
    }

    get renderConteudoDrawer() {
        return (
            <Fragment>
                <div style={{ width: '700px', margin: '15px 15px 0px', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ position: 'sticky', top: 0 }}>
                        <PainelFiltrosToolbar />
                    </div>
                </div>
                <div style={{ width: '700px', marginLeft: '8px' }}>
                    <FiltrosAtivos />
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        overflowX: 'auto',
                        margin: '8px 15px 15px',
                        width: '700px'
                    }}
                >
                    {this.renderFiltros}
                    <Divider />
                </div>
            </Fragment>
        );
    }

    get renderFiltros() {
        return this.filtrosPesquisados.map(
            (filtro) =>
                this.isComponenteHabilitado(filtro.idFiltro) &&
                filtro.isHabilitado && (
                    <Fragment key={'PF' + filtro.idFiltro}>
                        <Divider />
                        {filtro.tipo === 'booleano' ? (
                            <FiltroBooleano idFiltro={filtro.idFiltro} />
                        ) : (
                            <FiltroSelecao idFiltro={filtro.idFiltro} />
                        )}
                    </Fragment>
                )
        );
    }
}

export default inject('stores')(observer(DrawerFiltros));
